var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1669 19.0886H15.8354V13.9682C15.8354 12.7472 15.8101 11.1759 14.0994 11.1759C12.3624 11.1759 12.0971 12.5045 12.0971 13.8781V19.0886H8.76559V8.55914H11.9659V9.99439H12.009C12.4561 9.16689 13.5435 8.29342 15.168 8.29342C18.5436 8.29342 19.1679 10.4725 19.1679 13.309V19.0886H19.1669ZM5.00288 7.11838C4.74873 7.1185 4.49706 7.06946 4.26225 6.97406C4.02745 6.87867 3.81413 6.73879 3.63451 6.56244C3.45488 6.38608 3.31248 6.17671 3.21545 5.94632C3.11842 5.71592 3.06867 5.46901 3.06904 5.21973C3.06922 4.8444 3.18288 4.47755 3.39563 4.16557C3.60838 3.85359 3.91067 3.6105 4.26428 3.46703C4.61788 3.32357 5.00692 3.28617 5.3822 3.35957C5.75747 3.43298 6.10213 3.61388 6.37258 3.87941C6.64304 4.14494 6.82714 4.48317 6.90161 4.85133C6.97609 5.21949 6.93758 5.60104 6.79097 5.94773C6.64436 6.29442 6.39623 6.59069 6.07795 6.79906C5.75967 7.00744 5.38555 7.11856 5.00288 7.11838ZM6.67332 19.0886H3.33244V8.55914H6.67332V19.0886ZM20.8336 0.28418H1.66013C0.742418 0.28418 0 0.995826 0 1.87389V20.761C0 21.64 0.742418 22.3507 1.66013 22.3507H20.8308C21.7476 22.3507 22.4975 21.64 22.4975 20.761V1.87389C22.4975 0.995826 21.7476 0.28418 20.8308 0.28418H20.8336Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.a9bc7713e4eb31e7cf866eff8aecedd8.svg";
export { ForwardRef as ReactComponent };